<template>
  <q-layout>
    <q-page-container>
      <q-page style="width: 100%; height: 100%; padding: 0 5em 0">
        <SignOutButton class="signout-button" />

        <div style="display: inline-block; width: 100%; margin-top: 40px;">
          <HomeLogo />

          <div style="display: inline-block;
            position: relative;
            float: right;
            margin-top: 8px;
            "
          >
            <q-btn
              class="logDocumentButton"
              no-caps
              unelevated
              text-color="white"
              label="Document Logs"
              @click="setLogsMode('Document Logs')"
            />
            <q-btn
              class="logUserButton"
              no-caps
              unelevated
              text-color="white"
              label="User Logs"
              @click="setLogsMode('User Logs')"
            />
            <q-btn
              class="logUserGroupButton"
              no-caps
              unelevated
              text-color="white"
              label="User Group Logs"
              @click="setLogsMode('User Group Logs')"
            />
            <q-btn
              class="adminButton"
              no-caps
              unelevated
              text-color="black"
              label="Admin"
              @click="handleAdmin"
            />
            <HelpButtonAndDarkMode
              @toggleDarkMode="toggleDarkMode"
              helpScreen="logsPage"
            />
          </div>
        </div>

        <div>
          <div class="table_header">
            <span style="marginLeft: 20px">
              {{ logsMode }}
            </span>
          </div>

          <div style="width: 100%">
            <div v-show="logsMode === 'Document Logs'">
              <LogDocumentTable
                :currentUserUID="currentUserUID"
              />
            </div>

            <div v-show="logsMode === 'User Logs'">
              <LogUserTable
                :currentUserUID="currentUserUID"
              />
            </div>

            <div v-show="logsMode === 'User Group Logs'">
              <LogUserGroupTable
                :currentUserUID="currentUserUID"
              />
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>

    <AppFooter />
  </q-layout>
</template>

<script>
import SignOutButton from "../admin/SignOutButton.vue";
import HomeLogo, { handleHome } from "../layout/HomeLogo.vue";
import HelpButtonAndDarkMode from "../helpTour/HelpButtonDarkMode.vue";
import LogDocumentTable from "./LogDocumentTable.vue";
import LogUserTable from "./LogUserTable.vue";
import LogUserGroupTable from "./LogUserGroupTable.vue";
import AppFooter from "../layout/AppFooter.vue";
import { onBeforeMount, ref, watch } from "vue";
import AuthHelper from "../helper/AuthHelper.js";
import CommonHelper from "../helper/CommonHelper.js";
import router from "../../router";

export default {
  name: "AdminPage",
  components: {
    SignOutButton,
    HomeLogo,
    HelpButtonAndDarkMode,
    LogDocumentTable,
    LogUserTable,
    LogUserGroupTable,
    AppFooter
  },
  setup() {
    const currentUserUID = ref();

    function handleAdmin() {
      router.push("/admin");
    }

    onBeforeMount(async () => {
      const userData = await AuthHelper.getCurrentUserData(false, false);
      currentUserUID.value = userData.uid;

      if (currentUserUID.value !== process.env.VUE_APP_DEFAULT_USER_UID) {
        router.push("/unauth");
      }
    });

    const logsMode = ref("Document Logs");
    const darkMode = ref();

    function setLogsMode(newLogsMode) {
      logsMode.value = newLogsMode;
    }

    function toggleDarkMode(value) {
      darkMode.value = value;
    }

    // Sets the color of 'Document Logs', 'User Logs', 'User Group Logs', and 'Admin' buttons
    watch([logsMode, darkMode], () => {
      const documentLogsActive = logsMode.value === "Document Logs";
      document.documentElement.style.setProperty("--log-document-btn", CommonHelper.getHeaderButtonColor(documentLogsActive, darkMode.value));

      const userLogsActive = logsMode.value === "User Logs";
      document.documentElement.style.setProperty("--log-user-btn", CommonHelper.getHeaderButtonColor(userLogsActive, darkMode.value));

      const userGroupLogsActive = logsMode.value === "User Group Logs";
      document.documentElement.style.setProperty("--log-user-group-btn", CommonHelper.getHeaderButtonColor(userGroupLogsActive, darkMode.value));

      document.documentElement.style.setProperty("--admin-btn", darkMode.value ? "#FFFFFF" : "#000000");
    })

    return {
      //variable properties
      currentUserUID,
      logsMode,

      //functions
      handleAdmin,
      setLogsMode,
      toggleDarkMode,
      handleHome
    };
  },
};
</script>

<style type="text/scss" lang="scss">
:root {
  --log-document-btn: #0067c1;
  --log-user-btn: #707070;
  --log-user-group-btn: #707070;
  --admin-btn: #000000;
}
</style>

<style scoped>
.logDocumentButton {
  color: var(--log-document-btn) !important;
  font-size: 20px;
  margin-right: 8px;
}

.logUserButton {
  color: var(--log-user-btn) !important;
  font-size: 20px;
  margin-right: 8px;
}

.logUserGroupButton {
  color: var(--log-user-group-btn) !important;
  font-size: 20px;
  margin-right: 8px;
}

.adminButton {
  color: var(--admin-btn) !important;
  font-size: 20px;
}
</style>